import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Footer = () => {
  const [visitorCount, setVisitorCount] = useState(null);

  useEffect(() => {
    const recordVisit = async () => {
      try {
        // Check if visit already recorded in this session
        const visitRecorded = sessionStorage.getItem('kyle_drive_visit_recorded');
        
        if (!visitRecorded) {
          // First visit in this browser session - record it
          const response = await fetch(`${API_URL}/api/visitor-count/visit`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
          });
          
          if (response.ok) {
            const data = await response.json();
            setVisitorCount(data.count);
            sessionStorage.setItem('kyle_drive_visit_recorded', 'true');
          }
        } else {
          // Subsequent load in same session - just fetch count
          const response = await fetch(`${API_URL}/api/visitor-count`);
          if (response.ok) {
            const data = await response.json();
            setVisitorCount(data.count);
          }
        }
      } catch (error) {
        // Silently fail - counter failure must not affect website operation
        console.debug('Visitor counter unavailable');
      }
    };

    recordVisit();
  }, []);

  return (
    <footer id="contact" className="bg-[#0a1628] text-white py-10">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid md:grid-cols-3 gap-8 mb-6">
          {/* Logo and Brand */}
          <div className="flex flex-col space-y-4">
            <div className="flex flex-col items-start gap-2">
              {/* Logo with white background circle for visibility */}
              <div className="bg-white rounded-full p-3 inline-flex">
                <img 
                  src="/kyle-drive-logo.png" 
                  alt="Kyle Drive" 
                  className="h-16 w-auto"
                />
              </div>
              {/* White text tagline */}
              <p className="text-white font-semibold text-sm tracking-wide">
                KYLE DRIVE
              </p>
            </div>
            <p className="text-blue-200 text-sm leading-relaxed">
              Professional driving experiences at our secure off-road venue in Ayr, Scotland.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#book" className="text-blue-200 hover:text-white transition-colors">
                  Book Now
                </a>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-blue-200 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cancellation-policy" className="text-blue-200 hover:text-white transition-colors">
                  Cancellation Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact</h3>
            <div className="space-y-2 text-sm text-blue-200">
              <p>Kyle Rise Car Park</p>
              <p>Carrick Street</p>
              <p>Ayr, KA7 1RZ</p>
              <p className="pt-2">
                <a href="mailto:wheels@kyledrive.co.uk" className="hover:text-white transition-colors">
                  wheels@kyledrive.co.uk
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-cyan-900/30 pt-6 flex flex-col sm:flex-row justify-between items-center text-sm">
          <p className="text-white/60">© {new Date().getFullYear()} Kyle Drive. All rights reserved.</p>
          <p className="text-white font-bold tracking-wider mt-2 sm:mt-0">DRIVE • LEARN • BELONG</p>
          {visitorCount !== null && (
            <p className="text-xs text-white/40 mt-2 sm:mt-0">Visits: {visitorCount.toLocaleString()}</p>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
